<!--  -->
<template>
  <div class="detail">
    <multi></multi>
    <div class="main">
      <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
        <p class="title1">{{ infoList.title.othertitle }}</p>
        <p class="title2">
          {{ infoList.title.chinesetitle }}
          <span @click="toyiyu">
            <i class="el-icon-question"></i> 翻译不准确？试试人工翻译
          </span>
        </p>
        <p class="tagGroup">
          <span class="country" v-if="infoList.title.nationalFlag != null">
            {{ infoList.title.nationalFlag.chinesecountry
            }}
            <img
              :src="
                `http://182.61.21.235/images/${infoList.title.nationalFlag.nfaddress}`
              "
              alt
            />
          </span>
          <span v-else>暂无地区信息</span>
          <el-tag v-if="infoList.title.labelo != null">
            {{
            infoList.title.labelo
            }}
          </el-tag>
          <el-tag v-if="infoList.title.labelt != null">
            {{
            infoList.title.labelt
            }}
          </el-tag>
          <el-tag v-if="infoList.title.lables != null">
            {{
            infoList.title.lables
            }}
          </el-tag>
          <el-tag v-if="infoList.title.didbudget != null" type="warning">
            {{
            infoList.title.didbudget
            }}
          </el-tag>
          <el-tag v-if="infoList.title.didnotice != null" type="danger">
            {{
            infoList.title.didnotice
            }}
          </el-tag>
          <span
            class="kbrq"
            v-if="
              infoList.title.starttime != '' && infoList.title.starttime != null
            "
          >
            <i class="el-icon-time"></i>
            开标日期：{{
            infoList.title.starttime
            }}
          </span>
          <!-- >0f4d72 -->
        </p>
        <p class="info">
          <span v-if="infoList.title.didcustomer != null">customer：{{ infoList.title.didcustomer }}</span>
          <span>发布日期：{{ infoList.title.reletime }}</span>
          <span style="float:right;margin-right:0px;">
            收藏：
            <i
              :class="sc ? 'el-icon-star-on' : 'el-icon-star-off'"
              style="font-size:30px;vertical-align: sub;color:#ffda33;cursor: pointer;"
              @click="changesc"
            ></i>
          </span>
        </p>
        <el-tabs v-model="activeName" @tab-click="handletab">
          <el-tab-pane label="原文公告" name="1">
            <p
              v-html="infoList.content.otherlanguage"
              style="white-space: pre-line;line-height:50px;text-indent:28px"
            ></p>
          </el-tab-pane>
          <el-tab-pane label="AI翻译" name="2">
            <p
              v-html="infoList.content.chinesetext"
              style="white-space: pre-line;line-height:50px;text-indent:28px"
            ></p>
          </el-tab-pane>
          <el-tab-pane label="人工翻译" name="3"></el-tab-pane>
        </el-tabs>
        <div class="btn">
          <el-button
            type="primary"
            icon="el-icon-link"
            @click="linkDownload(infoList.content.ntbo)"
          >查看原文</el-button>
          <button class="yy" @click="toyiyu">人工翻译</button>
          <p class="explain">
            <i class="el-icon-warning-outline"></i>
            本网站不对所提供项目信息的真实性、准确性或可行性做出任何形式的保证，基于此信息而产生的任何法律后果与本网站无关。
          </p>
        </div>
      </div>
      <relevant :info="infoList.info" :title="infoList.title"></relevant>
      <p class="divider"></p>
      <div class="list" v-show="infoList.list.length != 0">
        <ul class="infoList">
          <li style="border-radius: 6px 6px 0 0;">
            <el-tag v-if="infoList.title.labelo != null">
              {{
              infoList.title.labelo
              }}
            </el-tag>
            <el-tag v-if="infoList.title.labelt != null">
              {{
              infoList.title.labelt
              }}
            </el-tag>
            <el-tag v-if="infoList.title.lables != null">
              {{
              infoList.title.lables
              }}
            </el-tag>的其他信息
          </li>
          <li v-for="(item, index) in infoList.list" :key="index">
            <p class="title1" @click="gotoDetail(item.bidid)">{{ item.othertitle }}</p>
            <p class="title2" @click="gotoDetail(item.bidid)">{{ item.chinesetitle }}</p>
            <p class="info">
              <span v-if="item.didcustomer != null">customer：{{ item.didcustomer }}</span>
              <span>发布日期：{{ item.reletime }}</span>
            </p>
            <p class="tagGroup">
              <span
                class="country"
                @click="countrygotoFind(item.countrgions)"
                v-if="item.nationalFlag != null"
              >
                {{ item.nationalFlag.chinesecountry
                }}
                <img
                  :src="
                    `http://182.61.21.235/images/${item.nationalFlag.nfaddress}`
                  "
                  alt
                />
              </span>
              <span v-else>暂无地区信息</span>
              <el-tag v-if="item.labelo != null" @click="hotgotoFind(item.labelo)">{{ item.labelo }}</el-tag>
              <el-tag v-if="item.labelt != null" @click="hotgotoFind(item.labelo)">{{ item.labelt }}</el-tag>
              <el-tag v-if="item.lables != null" @click="hotgotoFind(item.labelo)">{{ item.lables }}</el-tag>
              <el-tag
                v-if="item.didbudget != null"
                type="warning"
                @click="hotgotoFind(item.labelo)"
              >{{ item.didbudget }}</el-tag>
              <el-tag
                v-if="item.didnotice != null"
                type="danger"
                @click="hotgotoFind(item.labelo)"
              >{{ item.didnotice }}</el-tag>
              <span class="kbrq" v-if="item.starttime != '' && item.starttime != null">
                <i class="el-icon-time"></i>
                开标日期：{{
                item.starttime
                }}
              </span>
              <!-- >0f4d72 -->
            </p>
          </li>
        </ul>
        <!-- <p class="divider"></p>
        <ul class="infoList">
          <li>Here is the title of the original的其他信息</li>
          <li>
            <p class="title1">
              Here is the title of the original text Here is the title of the
              original text Here is the title text Here is
              texttexttexttexttexttexttexttexttexttexttext
            </p>
            <p class="title2">这里是中文标题这里是中文标题这里是中文标题</p>
            <p class="info">
              <span>customer：this is customer</span
              ><span>发布日期：2020-21-12</span>
            </p>
            <p class="tagGroup">
              <span class="country"
                >美国<img src="../assets/flag.jpg" alt=""
              /></span>
              <el-tag>标签一</el-tag>
              <el-tag type="success">标签二</el-tag>
              <el-tag type="info">标签三</el-tag>
              <el-tag type="warning">标签四</el-tag>
              <el-tag type="danger">标签五</el-tag>
              <span class="kbrq"
                ><i class="el-icon-time"></i>开标日期：2020-20-20</span
              >
              0f4d72
            </p>
          </li>
          <li>
            <p class="title1">
              Here is the title of the original text Here is the title of the
              original text Here is the title text Here is
              texttexttexttexttexttexttexttexttexttexttext
            </p>
            <p class="title2">这里是中文标题这里是中文标题这里是中文标题</p>
            <p class="info">
              <span>customer：this is customer</span
              ><span>发布日期：2020-21-12</span>
            </p>
            <p class="tagGroup">
              <el-tag>标签一</el-tag>
              <el-tag type="success">标签二</el-tag>
              <el-tag type="info">标签三</el-tag>
              <el-tag type="warning">标签四</el-tag>
              <el-tag type="danger">标签五</el-tag>
              <span class="kbrq"
                ><i class="el-icon-time"></i>开标日期：2020-20-20</span
              >
            </p>
          </li>
        </ul>-->
      </div>
    </div>
    <login :visible.sync="dialogFormVisible" @result="result"></login>
    <div v-show="jumpshow" class="mask">
      <div class="jumpPop">
        <img class="logo" src="../assets/clogo.png" alt />
        <i class="el-icon-close" @click="jumpshow=false"></i>
        <div class="box">
          <h4>即将离开牵星出海</h4>
          <p>您即将离开牵星出海，请注意您的账号和财产安全。</p>
          <p>{{urlPath}}</p>
          <el-divider></el-divider>
          <button @click="toOut(urlPath)">继续访问</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import relevant from '../components/relevant.vue'
import { API_1, Global } from '@/conf/api'
import tool from '../tool/tool'
import login from '../components/login.vue'
import multi from '../components/header.vue'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'detail',
  components: { multi, relevant, login },
  data() {
    //这里存放数据
    return {
      jumpshow: false,
      dialogFormVisible: false, //登录框显示or隐藏
      detailId: null,
      fullscreenLoading: false, //loading
      activeName: '1',
      infoList: {
        title: {},
        content: {},
        list: [],
        info: {},
      },
      uid: 0, //默认不登录为0
      sc: false, //收藏按钮状态
      scState: 1,
      urlPath: null,
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handletab(tab) {
      if (tab.index == 2) {
        this.$router.push({
          path: '/order',
        })
        setTimeout(() => {
          this.activeName = '1'
        }, 1000)
      }
    },
    toyiyu() {
      this.$router.push({
        path: '/order',
      })
    },
    changesc() {
      //收藏点击
      if (tool.getCookie('user')) {
        if (this.sc) {
          this.scState = 2
        } else if (this.sc == false) {
          this.scState = 1
        }
        let params = {
          cuid: this.uid,
          cbidid: this.detailId,
          colltype: this.scState,
        }
        this.axios
          .get(API_1 + Global.sc, { params: params })
          .then((res) => {
            if (res.data.status == 1) {
              this.sc = true
            } else if (res.data.status == 2) {
              this.sc = false
            }
          })
          .catch((res) => {
            console.log(res)
          })
      } else {
        this.dialogFormVisible = true
      }
    },
    result(val) {
      location.reload()
      // this.uid = tool.getCookie('user')
      // let token = tool.getCookie('qxchuhai')
    },
    hotgotoFind(val) {
      //跳转搜索页
      this.$router.push({
        path: 'find',
        query: { lable: val },
      })
    },
    countrygotoFind(val) {
      //跳转搜索页
      this.$router.push({
        path: 'find',
        query: { country: val },
      })
    },
    gotoDetail(id) {
      this.detailId = id
      this.getInfo()
    },
    toOut(url) {
      window.open(url, '_blank')
    },
    linkDownload(url) {
      if (tool.getCookie('user')) {
        this.jumpshow = true
        this.urlPath = url
        //  // 新窗口打开外链接
      } else {
        this.dialogFormVisible = true
      }
    },
    getInfo() {
      this.fullscreenLoading = true
      let top = document.documentElement.scrollTop || document.body.scrollTop
      document.body.scrollTop = document.documentElement.scrollTop = 0
      let params = {
        id: this.detailId,
        uid: this.uid,
      }
      this.axios
        .get(API_1 + Global.detail, { params: params })
        .then((res) => {
          this.infoList.title = res.data.data[0]
          this.infoList.content = res.data.data[1]
          // this.infoList.list = res.data.data[3]
          // this.infoList.info = res.data.data[5]
          if (res.data.data[2].uclection == 0) {
            //0未收藏 1收藏
            this.sc = false
          } else if (res.data.data[2].uclection == 1) {
            this.sc = true
          }
          this.fullscreenLoading = false
          //console.log(res.data.data)
        })
        .catch((res) => {
          console.log(res)
        })

      let params1 = {
        id: this.detailId,
      }
      this.axios
        .get(API_1 + Global.detailOther, { params: params1 })
        .then((res) => {
          this.infoList.list = res.data.data[0]
          this.infoList.info = res.data.data[1]
          //this.fullscreenLoading = false
          console.log(res.data.data)
        })
        .catch((res) => {
          console.log(res)
        })
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.detailId = this.$route.query.id
    let uid = tool.getCookie('user')
    if (uid == null) {
      this.uid = 0
    } else {
      this.uid = uid
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getInfo()
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
  @import '../style/css/websiteStyle.css'; /*引入公共样式*/
  //@import url(); 引入公共css类
  .mask {
    position: fixed;
    left: 50%;
    top: 50%;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 999;
    .jumpPop {
      background: #eff2f5;
      width: 550px;
      padding: 20px;
      z-index: 99;
      text-align: left;
      margin: 15% auto 0;
      i {
        float: right;
        color: #ccc;
        margin-top: 10px;
        cursor: pointer;
        font-size: 20px;
      }
      button {
        width: 150px;
        height: 40px;
        background: #0f4d72;
        border: 0;
        vertical-align: middle;
        color: #fff;
        float: right;
        &:hover {
          background: #105e8c;
        }
        margin-top: 0px;
      }
      .box {
        border: 1px solid #dcdcdc;
        border-radius: 6px;
        background: #fff;
        margin-top: 10px;
        padding: 10px;
        overflow: hidden;
        p {
          margin: 10px 0;
          word-wrap: break-word;
          word-break: normal;
        }
      }
      .logo {
        display: inline-block;
        width: 125px;
        height: 40px;
      }
    }
  }
  .explain {
    margin-top: 15px;
    color: #f56c6c;
    font-size: 13px;
  }
  .divider {
    //分割线
    // width: 100%;
    height: 40px;
    border-bottom: 1px dotted #fff;
    margin-bottom: 40px;
    width: 860px;
  }
  .detail {
    background: url('../assets/listbg.jpg') repeat-y center center;
    padding-top: 20px;
    .main {
      width: 1200px;
      min-width: 1200px;
      margin: 20px auto;
      .list {
        .infoList {
          width: 860px;
          li {
            .el-tag {
              margin-right: 20px;
              color: #0f4d72;
              background: rgba(15, 77, 114, 0.1);
              height: 24px;
              line-height: 21px;
              border: 1px solid transparent;
            }
            margin-top: 1px;
            //height: 170px;
            background: #fff;
            padding: 15px 40px;
            text-align: left;
            &:hover {
              .title1,
              .title2 {
                color: #0f4d72;
              }
            }
            .title1,
            .title2 {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              width: 800px;
              font-size: 16px;
              font-weight: bold;
              margin-bottom: 10px;
              color: #666;
              cursor: pointer;
            }
            .title2 {
              font-weight: inherit;
              margin-bottom: 20px;
            }
            .info {
              font-size: 12px;
              color: #999;
              margin-bottom: 20px;
              span {
                margin-right: 50px;
              }
            }
            .tagGroup {
              font-size: 12px;
              .el-tag {
                margin-left: 20px;
                cursor: pointer;
              }
              .country {
                cursor: pointer;
                img {
                  width: 34px;
                  height: 20px;
                  margin-left: 10px;
                  border: 1px solid #dcdcdc;
                }
              }
              .kbrq {
                font-size: 14px;
                float: right;
                color: #0f4d72;
              }
            }
          }
        }
      }
      .content {
        display: inline-block;
        text-align: left;
        background: #fff;
        border-radius: 4px;
        padding: 20px 40px 20px;
        width: 860px;
        box-sizing: border-box;
        .el-tabs {
          /deep/.el-tabs__item {
            color: #999;
          }
          /deep/.is-active {
            color: #0f4d72;
          }
          /deep/.el-tabs__active-bar {
            background: #0f4d72;
          }
          /deep/.el-tabs__content {
            .el-tab-pane {
              p {
                dl {
                  dt {
                    float: left;
                    width: 50%;
                    clear: both;
                    text-align: left;
                    text-indent: 0;
                  }
                  dd {
                    float: right;
                    width: 47%;
                    text-align: left;
                    text-indent: 0;
                  }
                }
              }
              table {
                border-collapse: collapse;
                border-spacing: 0;
                table-layout: fixed;
                tbody {
                  tr {
                    td {
                      width: 65%;
                    }
                  }
                }
              }
            }
          }
        }
        .btn {
          margin-top: 20px;
          span {
            color: #999;
            font-size: 14px;
          }

          .el-button {
            width: 150px;
            height: 40px;
            background: #0f4d72;
            border: 0;
            vertical-align: middle;
            &:hover {
              background: #105e8c;
            }
            /deep/i {
              font-size: 20px;
              vertical-align: middle;
            }
            span {
              vertical-align: middle;
            }
          }
          .yy {
            background-image: url('../assets/yy.png');
            background-position: 35px center;
            background-size: 22px 20px;
            background-repeat: no-repeat;
            background-color: #d32c3c;
            color: #fff;
            width: 150px;
            height: 40px;
            border-radius: 4px;
            padding-left: 30px;
            font-size: 14px;
            margin: 0 20px;
            cursor: pointer;
            &:hover {
              background-color: #e34151;
            }
          }
        }
        .title1,
        .title2 {
          width: 800px;
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 10px;
          color: #333;
        }
        .title2 {
          font-weight: inherit;
          margin-bottom: 20px;
          font-size: 16px;
          span {
            color: #0f4d72;
            text-decoration: underline;
            cursor: pointer;
            margin-left: 10px;
            &:hover {
              color: #178cd1;
            }
          }
        }
        .info {
          font-size: 14px;
          color: #999;
          margin-bottom: 20px;
          span {
            margin-right: 50px;
          }
        }
        .tagGroup {
          font-size: 14px;
          margin-bottom: 20px;
          .el-tag {
            margin-left: 20px;
            color: #0f4d72;
            background: rgba(15, 77, 114, 0.1);
            height: 24px;
            line-height: 21px;
          }
          .country {
            img {
              width: 34px;
              height: 20px;
              margin-left: 10px;
              border: 1px solid #dcdcdc;
            }
          }
          .kbrq {
            font-size: 14px;
            color: #0f4d72;
            margin-left: 30px;
          }
        }
      }
    }
  }
</style>
